<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh"><a id="pix">T<span class="small">ABLE OF</span> C<span class="small">ONTENTS</span></a></p><a id="pix">
<table width="70%">
<colgroup><col width="25%"/>
<col width="45%"/>
</colgroup><tbody><tr>
<td align="left" colspan="2"><p class="toc"><a href="#/acknowledgements"><i>Acknowledgements</i></a></p></td>
</tr>
<tr>
<td align="left" colspan="2"><p class="toc"><a href="#/introduction"><i>Introduction</i></a></p></td>
</tr>
<tr>
<td align="left"><p class="toc"><a href="#/chapter001">Chapter One</a></p></td>
<td align="left"><p class="toc"><a href="#/chapter001">Marriage Models</a></p></td>
</tr>
<tr>
<td align="left"><p class="toc"><span href="#/chapter002" title="Link target outside of Sample">Chapter Two</span></p></td>
<td align="left"><p class="toc"><span href="#/chapter002" title="Link target outside of Sample">A Glance Back</span></p></td>
</tr>
<tr>
<td align="left"><p class="toc"><span href="#/chapter003" title="Link target outside of Sample">Chapter Three</span></p></td>
<td align="left"><p class="toc"><span href="#/chapter003" title="Link target outside of Sample">The Beauty of Submission</span></p></td>
</tr>
<tr>
<td align="left"></td>
<td align="left"><p class="toc"><span href="#/chapter003a" title="Link target outside of Sample">Kathy O’Sullivan’s Story</span></p></td>
</tr>
<tr>
<td align="left"><p class="toc"><span href="#/chapter004" title="Link target outside of Sample">Chapter Four</span></p></td>
<td align="left"><p class="toc"><span href="#/chapter004" title="Link target outside of Sample">Sacrificial Love</span></p></td>
</tr>
<tr>
<td align="left"></td>
<td align="left"><p class="toc"><span href="#/chapter004a" title="Link target outside of Sample">Jeff and Bonnie</span></p></td>
</tr>
<tr>
<td align="left"><p class="toc"><span href="#/chapter005" title="Link target outside of Sample">Chapter Five</span></p></td>
<td align="left"><p class="toc"><span href="#/chapter005" title="Link target outside of Sample">Jesus, the One Who Bonds the Two</span></p></td>
</tr>
<tr>
<td align="left"></td>
<td align="left"><p class="toc"><span href="#/chapter005a" title="Link target outside of Sample">Greg and Tracey</span></p></td>
</tr>
<tr>
<td align="left"><p class="toc"><span href="#/chapter006" title="Link target outside of Sample">Chapter Six</span></p></td>
<td align="left"><p class="toc"><span href="#/chapter006" title="Link target outside of Sample">The Sanctuary</span></p></td>
</tr>
<tr>
<td align="left"><p class="toc"><span href="#/chapter007" title="Link target outside of Sample">Chapter Seven</span></p></td>
<td align="left"><p class="toc"><span href="#/chapter007" title="Link target outside of Sample">Come Away, My Lover</span></p></td>
</tr>
<tr>
<td align="left"><p class="toc"><span href="#/chapter008" title="Link target outside of Sample">Chapter Eight</span></p></td>
<td align="left"><p class="toc"><span href="#/chapter008" title="Link target outside of Sample">Choose the Better Way</span></p></td>
</tr>
<tr>
<td align="left" colspan="2"><p class="toct"><span href="#/a_prayer" title="Link target outside of Sample"><i>A Prayer for Marriages</i></span></p></td>
</tr>
<tr>
<td align="left" colspan="2"><p class="toc"><span href="#/notes" title="Link target outside of Sample"><i>Notes</i></span></p></td>
</tr>
<tr>
<td align="left" colspan="2"><p class="toc"><span href="#/abo_aut" title="Link target outside of Sample"><i>About the Author</i></span></p></td>
</tr>
</tbody></table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?24506a17